import urlAppRoot from '../internals/urlAppRoot';


export default function link(...levels: Array<string>): string {
	return levels.length ? `${urlAppRoot}/${levels.join('/')}` : `${urlAppRoot}`;
}
